<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        small
        v-on="on"
      >
        Create Separation Reason
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Separation Reason"
      text="Create Separation Reason"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="reason"
                v-validate="'required'"
                outlined
                :error-messages="errors.collect('reason')"
                data-vv-name="reason"                
                data-vv-as="reason"                
                label="Reason"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      separationTypeId: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        reason: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.progressing = true

          this.$api.separationReasons().create({ separation_type_id: this.separationTypeId, reason: this.reason })
            .then(response => {
              this.$emit('created', response.data)
              this.$snack({ message: 'Added new separation type' })

              this.dialog = false
            })
            .catch((err) => {
              if (err.response.status === 500) {              
                this.$snack({ 
                  color: 'error',
                  message: err.response.data.status, 
                })
              }            
            
              this.progressing = false
            })    
            .then(() => {
              this.progressing = false
            })
        })
      },
    
    },
  }
</script>
